import React from "react";
import { Construction } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

// Honest placeholder for modules that are not yet implemented.
// No data fetching and no fake connections (master context §13).
export function ModulePlaceholder({ module }: { module: string }) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-20 text-center"
      data-testid={`module-placeholder-${module.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100">
        <Construction className="h-6 w-6 text-slate-500" strokeWidth={1.75} />
      </div>
      <StatusBadge tone="amber">Not yet implemented</StatusBadge>
      <h3 className="mt-4 font-display text-xl font-medium text-slate-900">{module}</h3>
      <p className="mt-1.5 max-w-md text-sm text-slate-500">
        This module is part of the Version 1 scope and will be built as its own module. The foundation,
        navigation, and layout are ready — no placeholder or demo data is shown here on purpose.
      </p>
    </div>
  );
}
